<div class="container" [ngClass]="{'gipant-mode': activeTab === ACTIVE_TAB.GIPANT, 'henterpant-mode': activeTab === ACTIVE_TAB.HENTERPANT}">
  <div class="row">
    <div class="col-12 col-md-5 column">
      <div class="top-wrap">
        <div class="logo-wrap">
          <img *ngIf="activeTab === ACTIVE_TAB.GIPANT" ngSrc="../../../assets/images/logos/gipant-logo.svg" width="178" height="100" priority alt="giPant">
          <img *ngIf="activeTab === ACTIVE_TAB.HENTERPANT" ngSrc="../../../assets/images/logos/henterpant-logo.svg" width="276" height="100" priority alt="henterPant">
        </div>
        <div class="company-info">
          <ul>
            <li><p>Gi Pant AS</p></li>
            <li><p>Organization number: 934 988 809</p></li>
            <li><p>D.U.N.S number: 348149569</p></li>
          </ul>
        </div>
      </div>
      <div class="bottom-wrap">
        <div class="copyright">
          <p>© {{currentYear}} giPant. {{'FOOTER.COPY' | translate}}</p>
        </div>
      </div>
    </div>
    <div class="col-12 col-md-3 column">
      <div class="top-wrap">
        <h4>{{'FOOTER.MENU' | translate}}</h4>
        <ul>
          <li *ngFor="let navItem of navigation[activeTab]">
            <a [routerLink]="navItem.route || null" (click)="handleNavClick(navItem, $event)">{{navItem.title}}</a>
          </li>
        </ul>
        <div class="bank-logos">
          <a href="https://www.visa.no" target="_blank">
            <img ngSrc="../../../assets/images/logos/visa-secure.png" width="60" height="60" alt="Visa logo">
          </a>
          <a href="https://www.mastercard.no" target="_blank">
            <img ngSrc="../../../assets/images/logos/mc-logo.svg" class="mc" width="70" height="45" alt="MC logo">
          </a>
        </div>
        <p class="bank-logo visa"></p>
      </div>
      <div class="bottom-wrap">
        <a class="bottom-link" (click)="goToPage(true, false)">
          {{'FOOTER.TERMS' | translate}}
        </a>
      </div>
    </div>
    <div class="col-12 col-md-4 column">
      <div class="top-wrap">
        <h4>{{'FOOTER.CONTACTS' | translate}}</h4>
        <ul>
          <li><p><a href="mailto:pssst@gipant.no">pssst&#64;gipant.no</a></p></li>
          <li><p>Storgata 55, 8006 Bodø - Norway</p></li>
        </ul>
        <div class="socials-wrap">
          <ul>
            <li><a href="https://www.facebook.com/gipant" target="_blank"><i class="icon icon-brand-facebook"></i></a></li>
            <li><a href="https://x.com/" target="_blank"><i class="icon icon-twitter"></i></a></li>
            <li *ngIf="activeTab === ACTIVE_TAB.GIPANT"><a href="https://www.instagram.com/gipant_" target="_blank"><i class="icon icon-brand-instagram"></i></a></li>
            <li *ngIf="activeTab === ACTIVE_TAB.HENTERPANT"><a href="https://www.instagram.com/henterpant" target="_blank"><i class="icon icon-brand-instagram"></i></a></li>
          </ul>
        </div>
      </div>

      <div class="bottom-wrap">
        <a class="bottom-link" (click)="goToPage(false, true)">
          {{'FOOTER.PRIVACY' | translate}}
        </a>
      </div>
    </div>
  </div>
</div>
